function checkIfFieldValid(fieldValue, regex) {
   if(!fieldValue) {
      return 'data-field-invalid';
    }
    if (regex) {
      if( ! regex.test(fieldValue) ) {
        return 'data-field-invalid';
      }
    }




}


const REGEX = {
  EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
}

export {checkIfFieldValid, REGEX};
